
interface ContextErrorProps {
  className?: string;
}

export const ContextError = ({ className }: ContextErrorProps) => {
  return (
    <div className={`text-sm text-amber-500 p-2 rounded bg-amber-50 dark:bg-amber-900/20 mb-2 ${className}`}>
      Note: There was an issue saving chat history. Your messages will still be processed.
    </div>
  );
};
